import _extends from "@babel/runtime/helpers/extends";
import { useEffect } from 'react';
import { store } from './store';
export function Github(props) {
  useEffect(() => store.setCorners(_extends({}, props)), [props]);
  return null;
}